export const GOOGLE_ADS_CONVERSION_ID = "AW-11336030552";

export const GOOGLE_ADS_DOWNLOAD_AUDIO_ID = "5MdfCJjIk6AcENiyuJ0q";
export const GOOGLE_ADS_CLONE_VOICE_ID = "rHKNCJvIk6AcENiyuJ0q";

// First-party path that reverse-proxies the Google tag (Google tag gateway) so ad blockers don't drop it and its cookies are set from our own domain; the rewrite lives in next.config.ts
export const GOOGLE_TAG_GATEWAY_PATH = "/metrics";
